import { useCallback, useEffect, useRef, useState } from "react";
import { useNFTS } from "../../hooks/useNFTS";
import { ethers } from 'ethers';
import config from './../../config';
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { IAccount } from '../../types';
import { useAccount } from '../../hooks/useAccount';
import { setToast } from '../../store/actions/Toast';
import { Pot, Modal } from '../atoms';
import { CircularProgress } from '@mui/material';

const MainCard = (props: any) => {
  const dispatch: Dispatch<any> = useDispatch();
  let _account: IAccount = useAccount();
  const { ...account } = _account as any;
  const [bees, setBees] = useState<any>([]);
  const [selectedBees, setSelectedBees] = useState<any>([]);
  const [maxBeesSelect, setMaxBeesSelect] = useState(0);
  const [pots, setPots] = useState([]);
  const [usedPots, setUsedPots] = useState([0, 0, 0, 0, 0, 0]);
  const [potsBar, setPotsBar] = useState<any>([]);
  const [currentBee, setCurrentBee] = useState<any>(null);
  const [genValues, setGenValues] = useState<any>([0, 0, 0, 0, 0, 0]);
  const [sumAllPots, setSumAllPots] = useState<number>(0);
  const [selected, setSelected] = useState<number>(0);
  const [available, setAvailable] = useState<number>(0);
  const [staked, setStaked] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loadingUnstake, setLoadingUnstake] = useState(false);
  const [canStake, setCanStake] = useState(false);
  const [time, setTime] = useState<any>(0);
  const [selectStakedBees, setSelectStakedBees] = useState<any>([]);
  const [open, setOpen] = useState(false);

  const handleUnstakeModal = () => setOpen(!open);

  const myNFTs = useNFTS();
  const scrollEl = useRef<HTMLDivElement>(null!);
  const handleClickScrollToTop = useCallback(() => scrollEl.current.scrollTo({ top: 0, behavior: 'smooth' }), []);

  const stake = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    const signer = provider.getSigner();

    const yieldContract = new ethers.Contract(
      config.YieldAddress,
      config.YieldAbi,
      signer !== null ? signer : provider
    );
    const hpContract = new ethers.Contract(
      config.HoneyPotsAddress,
      config.HoneyPotsAbi,
      signer !== null ? signer : provider
    );

    try {
      setLoading(true)
      const isApproved = await hpContract.isApprovedForAll(
        account.account.address,
        config.YieldAddress
      );
      if (!isApproved) {
        const approveTx = await hpContract.setApprovalForAll(config.YieldAddress, true);
        const receipt = await approveTx.wait();
        if (receipt) {
          dispatch(
            setToast({
              visible: true,
              message: `Usage approved`,
              type: "success",
            })
          );
        } else {
          dispatch(
            setToast({
              visible: true,
              message: "An error has ocurred",
              type: "error",
            })
          );
          return;
        }
      }
      const finalBees = fillBees();
      const stakeObject = finalBees.map((so: any) => {
        const _generations = [];
        const _amounts = [];
        for (let index = 0; index < 6; index++) {
          if (so.pots[index] > 0) {
            _generations.push(index + 1);
            _amounts.push(so.pots[index]);
          }
        }
        return {
          beeId: so.bee.id,
          generations: _generations,
          amounts: _amounts,
          startTime: 0
        }
      })
      const stake = await yieldContract.stakeHP(stakeObject);
      dispatch(
        setToast({
          visible: true,
          message: "Transaction submitted. ",
          type: "success",
          etherLink: `https://etherscan.io/tx/${stake.hash}`,
        })
      )
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }

  }

  const init = async () => {
    if (myNFTs.nfts.bees) {
      const potsByBee = new Array(20);
      potsByBee.fill(0);
      const pots = myNFTs.nfts.pots?.map((pots: any, index: number) => ({ gen: index, pots: pots }))
      const bees = myNFTs.nfts.bees
        .map((bee: any, index: number) => ({ bee: bee, pots: potsByBee, gen1: 0, gen2: 0, gen3: 0, gen4: 0, gen5: 0, gen6: 0, selected: false }))
      const metaStaked = myNFTs.nfts.staked?.map((s: any) => ({
        ...s,
        bee: bees.find((b: any) => b.bee.id === s.beeId)?.bee || {}
      }))
        .filter((s: any) => s.beeId !== 0)

      const sumAvailable = pots.reduce((sum: number, pot: any) => sum + pot.pots, 0);
      const maxBees = Math.floor(sumAvailable / 20)
      setSelected(0)
      setUsedPots([0, 0, 0, 0, 0, 0])
      setSelectedBees([]);
      setGenValues([0, 0, 0, 0, 0, 0]);
      setMaxBeesSelect(maxBees > bees.length ? bees.length : maxBees)
      setAvailable(sumAvailable);
      setStaked(metaStaked)
      setPotsBar(potsByBee)
      setPots(pots)
      setBees(bees.filter((bee: any) =>
        !myNFTs.nfts.staked.map((s: any) => s.beeId).includes(bee.bee.id)))
      setCurrentBee(bees[0])
      setTime(myNFTs.nfts.supplyData?.endTime * 1000)
    }
  };
  const validateSelection = (selectedBee: any, isSelectAll: boolean) => {
    if (time <= 0) {
      dispatch(
        setToast({
          visible: true,
          message: "Yield has finished",
          type: "error",
        })
      );
      return false;
    }
    if (available < 20) {
      dispatch(
        setToast({
          visible: true,
          message: "Insufficient HoneyPots",
          type: "error",
        })
      );
      return false;
    }
    if (isSelectAll) {
      if (selectedBees.length === maxBeesSelect) {
        dispatch(
          setToast({
            visible: true,
            message: "Max BEES reached",
            type: "error",
          })
        );
        return false;
      }
    } else {
      if (selectedBees.length === maxBeesSelect && !selectedBee.selected) {
        dispatch(
          setToast({
            visible: true,
            message: "Max BEES reached",
            type: "error",
          })
        );
        return false;
      }
    }
    return true;
  }

  const selectBee = (selectedBee: any) => {
    if (!validateSelection(selectedBee, false)) return false;

    const beeIndex: number = bees.findIndex((bee: any) => bee.bee.id === selectedBee.bee.id)
    selectedBee.selected = !selectedBee.selected;
    bees[beeIndex] = selectedBee;
    setSelectedBees(bees.filter((bee: any) => bee.selected))
    setBees([...bees]);
    if (!selectedBee.selected) unselectBee();
  }
  const selectStakedBee = (selectedBee: any) => {
    const beeIndex: number = staked.findIndex((bee: any) => bee.bee.id === selectedBee.bee.id)
    selectedBee.selected = !selectedBee.selected;
    staked[beeIndex] = selectedBee;
    setSelectStakedBees(staked.filter((bee: any) => bee.selected))
  }

  const unstake = async () => {
    const stakedIds = selectStakedBees.map((s: any) => s.beeId)
    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    const signer = provider.getSigner();

    const yieldContract = new ethers.Contract(
      config.YieldAddress,
      config.YieldAbi,
      signer !== null ? signer : provider
    );

    try {
      setLoadingUnstake(true)
      const unstake = await yieldContract.unstake(stakedIds);
      dispatch(
        setToast({
          visible: true,
          message: "Transaction submitted. ",
          type: "success",
          etherLink: `https://etherscan.io/tx/${unstake.hash}`,
        })
      )
      setLoadingUnstake(false)
      setStaked(staked.filter((s: any) => !stakedIds.includes(s.beeId)))
    } catch (e) {
      setLoadingUnstake(false)
    }

  }


  const selectAll = () => {
    if (!validateSelection(null, true)) return false;

    const beesToMax = bees.filter((bee: any) => !bee.selected)
      .slice(0, maxBeesSelect - selectedBees.length)
      .map((bee: any) => ({ ...bee, selected: true }))
    const selectedIds = beesToMax.map((bee: any) => bee.bee.id);
    const leftBees = bees.filter((bee: any) => !bee.selected && !selectedIds.includes(bee.bee.id))


    setSelectedBees([...selectedBees, ...beesToMax])
    setBees([...selectedBees, ...beesToMax, ...leftBees]);
  }

  const unselectAll = () => {
    const unselectBees = bees
      .map((bee: any) => ({ ...bee, selected: false }))

    setUsedPots([0, 0, 0, 0, 0, 0])
    setGenValues([0, 0, 0, 0, 0, 0])
    setSelectedBees([])
    setBees([...unselectBees]);
  }

  const potValueChange = (value: number, gen: number) => {
    const gens = genValues;
    gens[gen] = isNaN(value) ? 0 : value;
    const totalSelectedPots = gens.reduce((sum: number, genValue: any) => sum + genValue, 0);
    if (totalSelectedPots > selectedBees.length * 20) return false
    const progress = totalSelectedPots === 0 ? 0 : (totalSelectedPots * 100) / (selectedBees.length * 20) / 100;
    const progressBar = Math.floor(20 * progress)
    let arrayFilledPots = []
    if (progressBar > 0) {
      arrayFilledPots = new Array(progressBar)
      arrayFilledPots.fill(1)
    }
    const arrayEmptyPots = new Array(20 - progressBar)
    arrayEmptyPots.fill(0)
    // setSumPotsByBee(totalSelectedPots)
    // setGenValues(gens)
    setUsedPots(gens)
    setPotsBar([...arrayFilledPots, ...arrayEmptyPots]);
    calculateUsedPots()
    // fillBees()
    // setSumPotsByBee(totalSelectedPots)
    // updateBees(value, gen, [...arrayFilledPots, ...arrayEmptyPots])
  }
  const calculateUsedPots = () => {
    // const allGen1 = bees.reduce((sum: number, bee: any) => sum + bee.gen1, 0);
    // const allGen2 = bees.reduce((sum: number, bee: any) => sum + bee.gen2, 0);
    // const allGen3 = bees.reduce((sum: number, bee: any) => sum + bee.gen3, 0);
    // const allGen4 = bees.reduce((sum: number, bee: any) => sum + bee.gen4, 0);
    // const sumGens = allGen1 + allGen2 + allGen3 + allGen4;
    const sumAvailable = pots.reduce((sum, pot: any) => sum + pot.pots, 0);
    const sumSelected = usedPots.reduce((sum: number, pots: any) => sum + Number(pots), 0);
    setAvailable(sumAvailable - sumSelected);
    setSelected(sumSelected);
    // setUsedPots([allGen1, allGen2, allGen3, allGen4])
  }

  const fillBees = () => {
    const dividePots = usedPots.map(pots => ({
      potsByBee: Math.floor(pots / selectedBees.length),
      residual: pots % selectedBees.length
    }))
    const fillBees: any = selectedBees.map((b: any) => ({
      ...b,
      pots: dividePots.map((p: any) => p.potsByBee)
    }))
    const incompleteBees = fillBees.filter((bee: any) => (bee.pots.reduce((sum: number, pots: any) => sum + pots, 0) < 20))
    const completeBees = fillBees.filter((bee: any) => (bee.pots.reduce((sum: number, pots: any) => sum + pots, 0) === 20))
    for (const fBee of incompleteBees) {
      const sumPots = fBee.pots.reduce((sum: number, pots: any) => sum + pots, 0)
      if (sumPots < 20) {
        let needsPots = 20 - sumPots;
        let aux = 0;
        for (let index = 0; index < 6; index++) {
          const currentValue = dividePots[index].residual;
          if (currentValue > 0 && needsPots !== aux) {
            const takedValue = (currentValue - (needsPots - aux)) > 0 ? (needsPots - aux) : currentValue;
            aux += takedValue;
            dividePots[index].residual = currentValue - takedValue;
            fBee.pots[index] = fBee.pots[index] + takedValue;
          }
        }

      }
    }
    return [...completeBees, ...incompleteBees]
  }

  const unselectBee = () => {
    let aux = 0;
    for (let index = 0; index < 6; index++) {
      const currentValue = usedPots[index];

      let needsPots = selected % 20 === 0 ? 20 : selected % 20;
      if (currentValue > 0 && needsPots !== aux) {
        const takedValue = (currentValue - (needsPots - aux)) > 0 ? (needsPots - aux) : currentValue;
        aux += takedValue;
        usedPots[index] = currentValue - takedValue;
      }
    }
    setUsedPots(usedPots)
  }

  const updateBees = (value: number, gen: number, potsBar: any) => {
    const changeBees: any = bees;
    const beeIndex: number = bees.findIndex((bee: any) => bee.bee.id === currentBee.bee.id)
    currentBee[`gen${gen + 1}`] = value;
    currentBee.pots = potsBar;
    changeBees[beeIndex] = currentBee;
    setBees(changeBees);
    calculateUsedPots()
  }

  useEffect(() => {
    init();
  }, [myNFTs]);

  useEffect(() => {
    setCanStake(account && account.account.address !== '')
  }, [account]);

  // useEffect(() => {
  //   if (currentBee) {
  //     setPotsBar(currentBee.pots)
  //     setGenValues([currentBee.gen1, currentBee.gen2, currentBee.gen3, currentBee.gen4])
  //   }
  // }, [currentBee]);

  return (
    <div className="main-card">
      <div className="main-header">
        <h1>Yield {props.nameToken}</h1>
        <div className='opensea-links'>
          <div className='buy-link'>
            <a href="https://opensea.io/collection/social-bees-university" target="_blank" rel="noopener noreferrer"> Buy BEES</a>
          </div>
          <div className='buy-link'>
            <a className='large' href="https://myhive.socialbees.io" target="_blank" rel="noopener noreferrer"> Buy HoneyPots</a>
          </div>
          <div className='buy-link'>
            <a href="https://monstermy.city" target="_blank" rel="noopener noreferrer"> Mint Monster</a>
          </div>
        </div>
      </div>
      {!canStake ?
        <div className="content">
          Connect your wallet first
        </div>
        : <div className="content">
          {(available > 0 || bees.length > 0) ?
            <div className='bees'>
              <h2>My BEES</h2>
              <div className='select-section'>
                <p>Select the BEES you want to use</p>
                <div className='btn-select'>
                  <button onClick={() => selectAll()} >Select all</button>
                  <button onClick={() => unselectAll()}>Unselect</button>
                </div>
              </div>

              <div className='my-bees'>
                {bees?.map((bee: any, key: number) =>
                  <div key={key} className='bee-container'>
                    {bee.selected ?
                      <img className='selected' src={bee.bee.image} onClick={() => selectBee(bee)} alt="" />
                      : <img src={bee.bee.image} onClick={() => selectBee(bee)} alt="" />
                    }
                  </div>
                )}
              </div>
            </div>
            : <div className='bees'>
              <div className='select-section'>
                <p>
                  At least 1 Bee and 20 Honeypots are required for yielding.
                </p>
              </div>
            </div>
          }
          <div className='honeypots'>
            <>
              <div className='hp-header'>
                <h2>My Honeypots</h2>
                <p>
                  Select the honeypots you want to use for these {selectedBees?.length} BEES.
                  Honeypots will be staked and become redeemable after the yield is complete by their corresponding BEES.
                  BEES won't be staked
                  but will be assigned to the 20 Honeypots staked,
                  allowing them to claim the rewards.
                </p>
              </div>
              <div className='body'>
                <div className='left'>
                  <div className='bar'>
                    {potsBar?.map((pot: any, key: number) =>

                    (pot === 0 ? <div key={key} className='bar-pot'></div>
                      : <div key={key} className='bar-pot-filled'></div>)
                    )}
                  </div>
                  <div className='expiration'>Staking expiration date:</div>

                  <div className='pots'>
                    {pots?.map((pot: any, key: number) =>
                      <Pot
                        key={key}
                        pots={pot.pots}
                        gen={pot.gen}
                        updatePots={potValueChange}
                        value={genValues[key]}
                        allUsedPots={selected}
                        usedPots={usedPots[pot.gen]}
                        maxPots={selectedBees.length * 20}
                      />
                    )}
                  </div>

                </div>
                <div className='right'>
                  <div className='available'>
                    <p><span>Available: </span>{available}</p>
                    <p><span>Selected: </span>{selected} / {selectedBees.length * 20}</p>
                  </div>
                  <div className='btn-stake'>
                    {loading ? <CircularProgress />
                      : <button onClick={stake} disabled={(selected !== selectedBees.length * 20) || selected === 0 || time <= 0}>
                        Stake
                      </button>}
                  </div>
                </div>
              </div>
            </>
          </div>
          {staked?.length > 0 && <div className='staked'>
            <div className='header'>
              <div className='title'>
                <h2>My staked Honeypots and their correlated BEES</h2>
                <p>
                  Remember to claim rewards and redeem staked Honeypots;
                  you must have their correlating BEE. So if the BEE is sold or transferred,
                  the new owner will now have the only rights to claim rewards and redeem the Honeypots.
                </p>
                <p>To unstake select the Bees and click "Unstake"</p>
              </div>
              <div className='btn-unstake'>
                {loadingUnstake ? <CircularProgress /> :
                  <button onClick={handleUnstakeModal} disabled={selectStakedBees.length === 0}>
                    Unstake
                  </button>}
              </div>
            </div>
            <div className='s-bees'>
              {staked?.map((s: any, key: number) =>
                s.beeId !== 0 && <div key={key} className='s-bee' >
                  <div className='s-pots'>
                    {s.generations.map((g: any, key: number) =>
                      <div key={key} className='s-pot'>
                        <img src={require("../../assets/pot.png").default} alt="" />
                        <p>{`${Number(s.amounts[key]._hex)} Gen${Number(g._hex)}`}</p>
                      </div>
                    )}
                  </div>
                  {s.selected ?
                    <img className='selected' src={s.bee?.image} alt="" onClick={() => selectStakedBee(s)} />
                    : <img src={s.bee?.image} alt="" onClick={() => selectStakedBee(s)} />
                  }
                </div>)
              }
            </div>
          </div>}
        </div>
      }
      <Modal
        isOpen={open}
        setIsOpen={handleUnstakeModal}
        closable={true}
        bodyClassName='wallet-modal-body'
      >
        <div className='wallet-modal'>
          <header className='wallet-modal__header'>Important! Make sure you've claimed</header>
          <div className='wallet-modal__body'>
              Before unstaking make sure you have claimed all your rewards.<br/>
              Once unstake you won’t be able to claim and your rewards will be lost.<br/>
              <div className='header'>
                <div className='btn-unstake'>
                  <button onClick={unstake} disabled={selectStakedBees.length === 0}>Unstake</button>
                </div>
                <div className='btn-cancel'>
                  <button onClick={handleUnstakeModal}>Cancel</button>
                </div>
              </div>
            </div>
        </div>
      </Modal>
    </div>
    
  );
};

export default MainCard;
